import type { RouteRecordRaw } from 'vue-router'
import CryptoWalletsPage from './CryptoWalletsPage.vue'
import VaspWalletOnboardingPage from './VaspWalletOnboardingPage.vue'
import WalletManagementPage from './WalletManagementPage.vue'
import WalletManagementDetailPage from './WalletManagementDetailPage.vue'
import { WALLET_MANAGEMENT_PATH, WALLET_MANAGEMENT_ROUTE } from './constants/walletManagementQueue'

export const cryptoWalletsRoutes: RouteRecordRaw[] = [
  {
    path: '/wallets/crypto-wallets',
    name: 'wallets.cryptoWallets',
    component: CryptoWalletsPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
  // Declared BEFORE the ':investorId' route below — vue-router matches in
  // registration order, so a literal segment declared afterwards would be
  // swallowed by the param route.
  {
    path: '/wallets/crypto-wallets/vasp-onboarding',
    name: 'wallets.cryptoWallets.vaspOnboarding',
    component: VaspWalletOnboardingPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
  {
    path: WALLET_MANAGEMENT_PATH.ALL,
    name: WALLET_MANAGEMENT_ROUTE.ALL,
    component: WalletManagementPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
  // The two work queues are the same table under a filter, so they share the
  // page component — but they get their own paths so the sidebar can highlight
  // them and the breadcrumb can name them. The filter is read from the route
  // name, not from a query param.
  {
    path: WALLET_MANAGEMENT_PATH.TRUSTLINE_APPROVALS,
    name: WALLET_MANAGEMENT_ROUTE.TRUSTLINE_APPROVALS,
    component: WalletManagementPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
  {
    path: WALLET_MANAGEMENT_PATH.FAILED_ON_CHAIN,
    name: WALLET_MANAGEMENT_ROUTE.FAILED_ON_CHAIN,
    component: WalletManagementPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
  // Where an order held at `awaiting_external_opt_in` sends the operator. The
  // optional `?offeringId=` query highlights the card that order is waiting on.
  {
    path: `${WALLET_MANAGEMENT_PATH.ALL}/:investorId`,
    name: WALLET_MANAGEMENT_ROUTE.DETAIL,
    component: WalletManagementDetailPage,
    meta: { layout: 'admin', requiresAuth: true },
  },
]
